<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0"
             role="tabpanel" style="height: 500px;">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="validate">
                    <div class="col-sm-12 col-lg-8 m-t-20">
                        <div class="form-group row">
                            <label class="text-right col-sm-4">Select Contract Type</label>
                            <div class="col-sm-8">
                                <div class="form-check">
                                    <input :class="{'is-invalid': submitted && errors.has('type')}"
                                           @click="setContractType"
                                           class="form-check-input"
                                           data-vv-as="type"
                                           id="PURCHASE"
                                           name="type"
                                           type="radio"
                                           v-model="contract.type"
                                           v-validate="'required'"
                                           value="PURCHASE">
                                    <label class="form-check-label" for="PURCHASE">Purchase</label>
                                </div>
                                <div class="form-check">
                                    <input :class="{'is-invalid': submitted && errors.has('type')}"
                                           @click="setContractType"
                                           class="form-check-input"
                                           data-vv-as="type"
                                           id="SALE"
                                           name="type"
                                           type="radio"
                                           v-model="contract.type"
                                           v-validate="'required'"
                                           value="SALE">
                                    <label class="form-check-label" for="SALE">Sale</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-8 m-t-20">
                        <div class="form-group row">
                            <label class="text-right col-sm-4 control-label col-form-label" for="partner">Select
                                Partner</label>
                            <div class="col-sm-8">
                                <multiselect
                                        :class="{'is-invalid': submitted && errors.has('partner')}"
                                        :clear-on-select="false"
                                        :close-on-select="true"
                                        :hide-selected="true"
                                        :internal-search="false"
                                        :limit="3"
                                        :loading="isLoading"
                                        :max-height="600"
                                        :options="partners"
                                        :options-limit="300"
                                        :searchable="true"
                                        :show-no-results="false"
                                        @search-change="searchPartners"
                                        class="form-control"
                                        data-vv-as="partner"
                                        id="partner"
                                        label="partner"
                                        name="partner"
                                        open-direction="up"
                                        placeholder="Search Partners"
                                        track-by="id"
                                        v-model="contract.partner"
                                        v-validate="'required'">
                                    <template slot="singleLabel" slot-scope="props">
                                        <div class="option__desc">
                                            <div class="option__desc">
                                                {{ props.option.biz_name }}
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="option__desc">
                                            <div class="option__desc" v-if="props.option">
                                                <h5>{{ props.option.biz_name }}</h5>
                                                <h6>{{ props.option.line1}}</h6>
                                                <h6>{{ props.option.city+', '+ props.option.country}}</h6>
                                            </div>
                                            <div class="option__desc" v-else>
                                                <h5>Add New</h5>
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="afterList">
                                        <div class="col-xs-12" v-if="contract.type==='SALE'">
                                            <router-link :to="{name: 'addbuyer'}" class="btn btn-block btn-lg btn-outline-success">
                                                <i class="fa fa-plus-circle"></i>&nbsp;Add Buyer
                                            </router-link>
                                        </div>
                                        <div class="col-xs-12" v-if="contract.type==='PURCHASE'">
                                            <router-link :to="{name: 'addseller'}" class="btn btn-block btn-lg btn-outline-success">
                                                <i class="fa fa-plus-circle"></i>&nbsp;Add Seller
                                            </router-link>
                                        </div>
                                        <div class="col-xs-12 btn-group" style="display: flex" v-if="!contract.type">
                                            <router-link :to="{name: 'addbuyer'}" class="btn btn-outline-success" style="flex: 1">
                                                <i class="fa fa-plus-circle"></i>&nbsp;Add Buyer
                                            </router-link>
                                            <router-link :to="{name: 'addseller'}" class="btn btn-outline-success" style="flex: 1">
                                                <i class="fa fa-plus-circle"></i>&nbsp;Add Seller
                                            </router-link>
                                        </div>
                                    </template>
                                </multiselect>
                                <div class="invalid-feedback" v-if="submitted && errors.has('partner')">{{ errors.first('partner') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-8">
                        <div class="form-group row" id="data_1">
                            <label class="text-right col-sm-4 control-label col-form-label" for="expires_at">Contract Expiry Date</label>
                            <div class="input-group col-sm-8">
                                <div class="input-group-prepend date">
                                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                </div>
                                <input :class="{'is-invalid': submitted && errors.has('expires_at')}"
                                       class="form-control"
                                       data-vv-as="expire_date"
                                       id="expires_at"
                                       name="expires_at"
                                       placeholder="mm/dd/yyyy"
                                       type="text"
                                       v-model="contract.expires_at"
                                       v-validate="isForward ? 'required': ''">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-8">
                        <div class="form-group row">
                            <label class="text-right col-sm-4 control-label col-form-label" for="expires_at">Provenance</label>
                            <div class="input-group col-sm-8">
                                <input id="provenance"
                                       name="provenance"
                                       class="form-control"
                                       data-vv-as="provenance"
                                       placeholder="Provenance"
                                       style="height: 42px; width: calc(100% - 70px)"
                                       type="text"
                                       v-model="contract.provenance">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';

    export default {
        name: "ContractProps",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Multiselect},
        mounted() {
            this.$nextTick(() => {
                this.init();
            })
        },
        data() {
            return {
                submitted: false,
                isForward: false,
                isLoading: false,
                partners: [],
                contract: this.$parent.contract
            }
        },
        methods: {
            init() {
                jQuery('#expires_at').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.contract.expires_at = event.target.value;
                });
            },
            setContractType(event) {
                this.contract.type    = event.target.value;
                this.partners         = [];
                this.contract.partner = null;
            },
            async validate() {
                this.submitted = true;
                let valid      = await this.$validator.validate();
                return valid;
            },
            async searchPartners(searchText) {
                try {
                    this.isLoading = true;
                    let reply;
                    if(this.contract.type === 'PURCHASE') {
                        reply = await this.$http.get("/express/" + this.currentOrg.express_id + "/purchases/sellers/search", {
                            params: {
                                search: searchText
                            }
                        });
                    } else if(this.contract.type === 'SALE') {
                        reply = await this.$http.get("/express/" + this.currentOrg.express_id + "/sales/buyer/search", {
                            params: {
                                search: searchText
                            }
                        });
                    }
                    this.partners  = reply.data;
                    this.isLoading = false;
                } catch(e) {
                    console.log(e);
                }
            },
        }
    }
</script>

<style scoped>

</style>
